<template>
  <div class="max-w-360 m-auto w-full flex justify-center">
    <div class="flex flex-col gap-3 p-4 w-207 rounded-8xl glass-frosted">
      <Updator />

      <FrequencyBand v-if="cafeBaseAdminCanShow" />

      <Brightness v-if="hasBrightness" />

      <ProductDisplay />

      <FactoryReset />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDeviceStore } from '@/stores/device'
  import { useAdminOnly } from '@/composables/useAdminOnly'
  import Updator from './components/Updator.vue'
  import { useRestoreChildDevice } from '../composables/useRestoreChildDevice'
  import FrequencyBand from './components/FrequencyBand.vue'
  import Brightness from './components/Brightness.vue'
  import ProductDisplay from '@/components/settings/ProductDisplay.vue'
  import FactoryReset from '@/components/settings/FactoryReset.vue'

  useRestoreChildDevice()

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)
  const { cafeBaseAdminCanShow } = useAdminOnly()

  const hasBrightness = computed(() => {
    return currentDevice.value?.manifest.capabilities.some(
      (item) => item.type === 'baseScreen' && item.config.screenType === 'screen',
    )
  })
</script>

<style lang="scss" scoped></style>
